import React from "react";
import PolicyLayout from "./PolicyLayout";
import { SITE_CONFIG } from "../config/siteConfig";

function ContactPolicy() {
  return (
    <PolicyLayout
      title="Contact information policy"
      intro="Use the verified mavormira support channel for order, product, privacy, safety, accessibility or policy questions."
    >
      <section>
        <h2>Verified channel</h2>
        <p>Email <a href={`mailto:${SITE_CONFIG.supportEmail}`}>{SITE_CONFIG.supportEmail}</a>. The site's contact page validates the fields and opens a draft in the visitor's email application; the message is sent only when the visitor sends it from that application.</p>
      </section>

      <section>
        <h2>What to include</h2>
        <p>For an order, give the order number, purchaser email, product name and the specific question. For delivery or condition problems, attach clear photographs of the product, parcel, label and packaging. For a site barrier, give the page, device and action attempted. For a privacy request, identify the data and interaction to be located.</p>
      </section>

      <section>
        <h2>Information not to email</h2>
        <p>Do not send a complete card number, card security code, payment password or one-time authentication code. Keep government identification out of ordinary email; if identity proof becomes legally necessary, support must first explain the limited purpose and an appropriate submission method. Support will not ask you to change payment details by replying with card credentials.</p>
      </section>

      <section>
        <h2>Recognising official information</h2>
        <p>Brand, operating region, currency, email and any displayed address are taken from the site's central configuration. Treat a conflicting contact or payment instruction as suspicious and return to this site directly. Product-safety emergencies should also be directed to the appropriate local emergency or medical service.</p>
      </section>
    </PolicyLayout>
  );
}

export default ContactPolicy;
